import type { BrokerTabKey } from "./brokerLoadBucket";

export interface BrokerRowStatusInput {
  bucket: Exclude<BrokerTabKey, "all">;
  bid_status: string;
  is_awarded: boolean;
  dispatch_status: string | null;
  dispatch_archived_at: string | null;
  load_status?: string | null;
  load_missing?: boolean;
}

export interface BrokerRowStatus {
  label: string;
  tone: string;
}

const TONE = {
  neutral: "bg-muted text-muted-foreground border-border",
  blue: "bg-blue-500/15 text-blue-600 border-blue-500/30",
  emerald: "bg-emerald-500/15 text-emerald-600 border-emerald-500/30",
  teal: "bg-brand-teal/15 text-brand-teal border-brand-teal/30",
  rose: "bg-rose-500/15 text-rose-600 border-rose-500/30",
  muted: "bg-muted text-muted-foreground border-border",
};

export function brokerRowStatus(r: BrokerRowStatusInput): BrokerRowStatus {
  switch (r.bucket) {
    case "bidding":
      if (r.bid_status === "countered") return { label: "Countered", tone: TONE.blue };
      return { label: "Bidding", tone: TONE.neutral };
    case "awarded":
      return { label: "Awarded", tone: TONE.emerald };
    case "dispatching":
      return { label: "Dispatching", tone: TONE.teal };
    case "in_transit":
      return { label: "In Transit", tone: TONE.blue };
    case "delivered":
      return { label: "Delivered", tone: TONE.emerald };
    case "closed":
      return { label: "Closed", tone: TONE.muted };
    case "archive":
      if (r.dispatch_archived_at) return { label: "Archived", tone: TONE.muted };
      if (r.bid_status === "withdrawn") return { label: "Withdrawn", tone: TONE.muted };
      if (r.bid_status === "rejected") return { label: "Rejected", tone: TONE.rose };
      if (r.bid_status === "lost") return { label: "Lost", tone: TONE.muted };
      if (r.load_missing) return { label: "Removed by shipper", tone: TONE.rose };
      if (r.load_status === "canceled" || r.load_status === "cancelled")
        return { label: "Cancelled by shipper", tone: TONE.rose };
      if (r.load_status === "expired") return { label: "Bidding closed", tone: TONE.muted };
      if (r.load_status === "completed") return { label: "Closed", tone: TONE.muted };
      return { label: "Archived", tone: TONE.muted };
    default:
      return { label: "—", tone: TONE.muted };
  }
}
